<template>
    <div class="microTrain">
        <a-back-top />
        <div class="microTrainTop dfafe">
            <p style="color:#333333;font-size:26px;">课例观摩与解课</p>
        </div>
        <div>
            <br>
            <div style="text-align:left;">
                <span style="font-size:16px;">学段：</span>
                <span 
                    v-for="(item, index) in sectionArr" 
                    :class="[sectionArrIndex == index ? 'on' : '' , 'microTrainSpan']"
                    @click="changeTab(index)"
                >
                    {{ item.value }}
                </span>
            </div>
            <br>
            <div style="text-align:left;">
                <span style="font-size:16px;">学科：</span>
                <span 
                    v-for="(item, index) in subjectArr" 
                    :class="[subjectArrIndex == index ? 'on' : '' , 'microTrainSpan']"
                    @click="changeTab1(index)"
                >
                    {{ item.value }}
                </span>
            </div>
            <br>
        </div>
        <div>
            <div class="courseListBox2">
                <div class="courseWrap">
                    <!-- <div v-for="(item, index) in oneCourse" @click="goHref(item)">
                        <div class="oneCourse">
                            <img src="../../../static/images/course_bg.png" width="100%" height="169" alt="">
                            <div class="courseInfo">
                                <p>《{{ item.courseName }}》</p>
                                <div class="realname">
                                    <span>{{ item.authorName }}</span>
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div v-for="(cour, index) in oneCourse">
                        <div class="oneCourse" @click="goVideo(cour.courseViewId)">
                            <img :src="cour.coverUrl?cour.coverUrl:require('../../../static/images/course_bg.png')" width="283" height="169" alt="">
                            <div class="courseInfo">
                                <p>{{cour.courseName}}</p>
                                <div class="realname">
                                    <span>{{cour.authorName}}</span>
                                    <span>{{cour.sectionName}}{{cour.subjectName}}</span>
                                </div>
                                <div class="toCourseBtn">去解课</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    data() {
        return {
            oneCourse:[],
            sectionArr: [
                {
                    value: '全部',
                    text:'全部'
                },
                {
                    value: '小学',
                    text:'小学'
                },
                {
                    value: '初中',
                    text:'初中'
                },
            ],
            sectionArrIndex:0,
            subjectArr: [
                {
                    value: '全部',
                    text:'全部'
                },
                {
                    value: '语文',
                    text:'语文'
                },
                {
                    value: '数学',
                    text:'数学'
                },
                {
                    value: '地理',
                    text:'地理'
                },
                {
                    value: '物理',
                    text:'物理'
                },
                {
                    value: '化学',
                    text:'化学'
                },
                {
                    value: '生物',
                    text:'生物'
                },
                {
                    value: '音乐',
                    text:'音乐'
                },
                {
                    value: '美术',
                    text:'美术'
                },
                {
                    value: '科学',
                    text:'科学'
                },
                {
                    value: '道德与法治',
                    text:'道德与法治'
                },
            ],
            subjectArrIndex:0,
        }
    },
    components: {

    },
    mounted () {
        this.courseExampleView();
    },
    methods: {
        changeTab(index){
            this.sectionArrIndex = index;
            this.courseExampleView();
        },
        changeTab1(index){
            this.subjectArrIndex = index;
            this.courseExampleView();
        },
        courseExampleView(){
            let where = {};
            if (this.sectionArrIndex != 0){
                where['sectionName_eq'] = this.sectionArr[this.sectionArrIndex].value;
            }
            if (this.subjectArrIndex != 0){
                where['subjectName_eq'] = this.subjectArr[this.subjectArrIndex].value;
            }
            this.axios.post(this.appUtils.getSignWithUrl(this.apis.home.courseExampleView+'?currentPage=1&pageSize=1000'),{
                "where": where,
                "orderBy": {
                    "created_dt": "asc"
                }
            })
            .then((res)=>{
                console.log(res);
                this.oneCourse = res.data.data;
            }).catch((err)=> {
                console.log(err);
            });
        },
        goVideo(id){
            // goVideo
            // window.open('/match/videoDetail?videoid='+id);
            this.$router.push('/videoDetail?videoid='+id);
        },
        // abilitytrain (){
        //     this.axios.post(this.appUtils.getSignWithUrl(this.apis.home.abilityTrain+'?currentPage=1&pageSize=1000'))
        //     .then((res)=>{
        //         console.log(res);
        //         this.oneCourse = res.data.data;
        //     }).catch((err)=> {
        //         console.log(err);
        //     });
        // },
        goHref(item){
            // console.log(item);
            window.open(item.researchStudyUrl);
        }
    },
    created(){

    },
  }
</script>

<style lang="scss">
    .h60{
        height: 60px;
    }
    .bgF3{
        background-color: #F3FBFF;
    }
    .c3{
        color: #333333;
    }
    .c9{
        color: #999999;
    }
    .f24{
        font-size: 24px;
    }
    .f18{
        font-size: 18px;
    }
    .pd20_0{
        padding: 20px 0;
    }
    .pd0_20{
        padding: 0 20px;
    }
    .pd20{
        padding: 20px;
    }
    .pd10{
        padding: 10px;
    }
    .fw{
        font-weight: bold;
    }
    .dfsbc{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .dfsbe{
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }
    .dfaf{
        display: flex;
        justify-content: flex-start;
        align-content: flex-start;
    }
    .dfafe{
        display: flex;
        justify-content: flex-start;
        align-content: flex-end;
        align-items: flex-end;
    }
    .microTrain{
        width: 1200px;
        margin: 64px auto 0;
        .microTrainTop{
            padding: 35px 0 15px;
        }
    }
    .microTrainSpan{
        font-size: 14px;
        cursor: pointer;
        padding: 0 10px;
        display: inline-block;
    }
    .on.microTrainSpan{
        color: #1890FF;
    }
    .courseListBox2 {
        .courseWrap {
            padding-bottom: 20px;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            & > div {
                flex: 0 1 25%;
            }
            .oneCourse {
                margin: 15px auto;
                width: 283px;
                height: 289px;
                text-align: left;
                cursor: pointer;
                overflow: hidden;
                border-radius: 10px;
                &:hover {
                    box-shadow: 0px 5px 20px #cce5ff;
                }
                &:hover .courseInfo .toCourseBtn {
                    background: #1890FF;
                    color: #fff;
                }
                &:hover .courseInfo p {
                    color: #1890FF;
                }
                &:hover .realname span {
                    color: #1890FF;
                }
                .courseInfo {
                    height: 120px;
                    padding: 20px;
                    position: relative;
                    background: #fff;
                    .toCourseBtn {
                        width: 80px;
                        height: 32px;
                        line-height: 32px;
                        background: #E6F7FF;
                        position: absolute;
                        bottom: 10px;
                        right: 10px;
                        color: #8FC4F5;
                        text-align: center;
                    }
                    &>p {
                        font-family: Microsoft YaHei;
                        line-height: 20px;
                        color: #1890FF;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        font-weight: bold;
                        font-size: 16px;
                    }
                    .realname {
                        font-size: 14px;
                        color: #999;
                        margin-top: 5px;
                        display: inline-block;
                        padding-top: 10px;
                        span {
                            margin-right: 10px;
                        }
                    }
                }
            }
        }
        .ant-carousel .slick-dots-bottom {
            bottom: -34px;
        }
        .ant-carousel .slick-slide {
            text-align: center;
            // height: 160px;
            // line-height: 160px;
            overflow: hidden;
        }
        .ant-carousel .slick-dots li button {
            width: 7px;
            height: 7px;
            background: #2680EB;
            border-radius: 50%;
            opacity: 0.47;
        }
        .ant-carousel .slick-dots li.slick-active button {
            width: 10px;
            height: 10px;
            opacity: 1;
        }
        .ant-carousel .slick-dots {
            height: 10px;
            line-height: 10px;
        }
    }
</style>
